import { render, staticRenderFns } from "./NbaTeamStack.vue?vue&type=template&id=071bbaa2&scoped=true"
import script from "./NbaTeamStack.vue?vue&type=script&lang=js"
export * from "./NbaTeamStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071bbaa2",
  null
  
)

export default component.exports